import type { SearchPageFilter } from "./_types";
import logEvent from "./logEvent";
import type { LoggingEvent } from "./logEvent";

/**
 *
 * @param props This object contains
 */

const searchPageView = ({ filter, value, state }: SearchPageFilter) => {
  // UA
  // This is handled by the default pageView

  // Tag Manager
  let layerUpdate: LoggingEvent = { event: "search_page_view" };

  if (filter) layerUpdate.filter = filter;
  if (value) layerUpdate.value = value;
  if (state) layerUpdate.state = state;

  logEvent(layerUpdate);
};

export default searchPageView;
